import { observable, action } from 'mobx'
import { services, utils } from '@tfo/common'
import { IndividualViewStore } from './IndividualViewStore'
import { LoginStore } from './LoginStore'
import { UserStore } from './UserStore'
import { NotationStore } from './NotationStore'

//todo: this duplicates rootStore in CustomerPortal, move to common
export default class RootStore {
	@observable userStore = new UserStore(this)
	@observable loginStore = new LoginStore(this)
	@observable notationStore = new NotationStore(this)
	@observable individualViewStore = new IndividualViewStore(this)
	network = new services.Network()

	constructor() {
		if (utils.loggedIn()) {
			this.login(utils.COOKIE)
		}
	}

	@action public goBack() {
		window.history.back()
	}

	login = (cookie?: string) => {
		//FIXME Manual init is brittle, make stores listen to each other
		this.network.authenticate(cookie)
		this.userStore.updateUser(utils.getCookie(cookie))
		return this.individualViewStore.init()
	}
}
